var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typo typo--sm typo--secondary mt-2"},[_vm._v(" Dostępna w "),_c('strong',[_vm._v(_vm._s(_vm.data.subscriptions.filter((el) => el.state === 'available') .length)+" z ")]),_c('span',{domProps:{"innerHTML":_vm._s(
            _vm.$options.filters.plurals(
                _vm.data.subscriptions.length,
                'sklepu',
                'sklepów',
                undefined,
                true
            )
        )}})])
}
var staticRenderFns = []

export { render, staticRenderFns }